<template>
  <div id="global-loading" class="overlay">
    <img src="/img/CARDS_BRA_LOADING.gif" alt="Loading..." class="spinner">
  </div>
  <component v-if="headerComponent" :is="headerComponent" />

  <router-view v-if="!isStoreRoute" />

  <component v-if="showFooter && footerComponent" :is="footerComponent" />
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
  components: {

  },
  computed: {
    isStoreRoute() {
      return this.$route.path.includes('my-store');
    },
    isCheckoutRoute() {
      return this.$route.path.includes('checkout');
    },
    showFooter() {
      return !this.$route.path.includes('/hide-menu');
    },
    headerComponent() {
      if (this.isStoreRoute) {
        return defineAsyncComponent(() =>
          import('./Components/HeaderStore.vue')
        );
      }

      else if (this.isCheckoutRoute) {
        return defineAsyncComponent(() =>
          import('./Components/HeaderCheckout.vue')
        );
      }

      return defineAsyncComponent(() =>
        import('./Components/Header.vue')
      );
    },
    footerComponent() {
      if (!this.isStoreRoute && !this.isCheckoutRoute) {
        return defineAsyncComponent(() =>
          import('./Components/Footer.vue')
        );
      }


    }
  }
};
</script>
<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.6); /* fundo branco com transparência */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* garantir que fique no topo */
}
.spinner{
  width: 200px;
}
.hide{
  display:none !important;
}



</style>